import { EntityService } from 'utils/entityService';
import { ConsumptionPlaceUploadModel, ListResponseModel, QueryParamModel } from 'models';
import request, { Methods, requestFile } from 'utils/request';
import { exportFile } from 'utils/exportFile';

class ConsumptionPlaceUploadService extends EntityService {
  constructor() {
    super('admin/consumption-place-loader');
  }

  async getList(params?: QueryParamModel | null) {
    return request<ListResponseModel<ConsumptionPlaceUploadModel>>({
      method: Methods.GET,
      resource: this.resource,
      params,
    });
  }

  async upload(files: File[]) {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files', file);
    });

    return request<void>({
      method: Methods.POST,
      resource: this.resource,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: formData,
    });
  }

  async downloadLog(id: number) {
    const response = await requestFile<BlobPart>({
      method: Methods.GET,
      resource: `${this.resource}/${id}/log`,
    });
    exportFile(response);
    return response;
  }
}

export const consumptionPlaceUploadService = new ConsumptionPlaceUploadService();
